import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EnvelopeSignatory } from '../model/envelope-signatory';
import { Signatory } from 'src/app/envelope/model/signatory';
import { EnvelopeSignatoryGetResponse } from '../model/envelope-signatory-detail-lists';
import { FormCustomFieldModel } from '../model/form-custom-field-model';

const CONTROLLER = 'envelopesignatory';

@Injectable({
  providedIn: 'root'
})
export class EnvelopeSignatoryService {

  constructor(private http: HttpClient) {
  }

    public get(batch: boolean): Observable<EnvelopeSignatoryGetResponse> {
    return this.http.get<EnvelopeSignatoryGetResponse>(CONTROLLER + '?batch=' + batch)
      .pipe(
        map((response: EnvelopeSignatoryGetResponse) => response),
        catchError(this.handleError)
      );
  }

  public getResumeDetails(id: number, obfuscateMail: boolean): Observable<any> {
    return this.http.get<Signatory>(CONTROLLER + '/getSummary/' + id + '?obfuscateMail=' + obfuscateMail)
      .pipe(
        map((response: Signatory) => response),
        catchError(this.handleError)
      );
  }

  public getDetailByAccessKey(accessKey: string): Observable<EnvelopeSignatory> {
    return this.http.get<EnvelopeSignatory>(CONTROLLER.concat('/getDetail/').concat(accessKey))
      .pipe(
        map((response: any) => response.value),
        catchError(this.handleError)
      );
  }

  public approve(accessKey: string): Observable<any> {
    return this.http.put(CONTROLLER.concat('/approve/').concat(accessKey), {});
  }

  public reprove(accessKey: string, motive: string): Observable<any> {
    return this.http.put(CONTROLLER.concat('/reprove/').concat(accessKey), { motive });
  }

  public verificationCodeByAccessKey(accessKey: string): Observable<string> {
    return this.http.get<string>(CONTROLLER + '/getVerificationToken/' + accessKey)
      .pipe(
        map((response: any) => response),
        catchError(this.handleError)
      );
  }

  public filledResponsible(accessKey: string, fields: FormCustomFieldModel[]): Observable<any> {
    return this.http.put('enveloperesponsible/filled/' + accessKey, fields);
  }

  private handleError(errorResponse: Response) {
    console.log(errorResponse.statusText);
    return Observable.throw(errorResponse || 'Server error');
  }
}
